import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import SearchComponent from '../PricingHub/SearchComponent';

class TransactionsSearchForm extends SearchComponent {
  searchInputs = [
    {
      label: 'common:label.billUnitId',
      name: 'billUnitId',
    },
    {
      label: 'common:label.invoiceUnitId',
      name: 'invoiceUnitId',
      fa: 'fa fa-external-link',
    },
    {
      label: 'common:label.type',
      name: 'type',
      type: 'select',
      tOptions: 'selections:transactionType',
      isClearable: true,
    },
    {
      label: 'common:label.serviceType',
      name: 'serviceType',
      type: 'select',
      tOptions: 'selections:serviceType',
      isClearable: true,
    },
    {
      label: 'common:label.itemId',
      name: 'itemId',
      fa: 'fa fa-external-link',
    },
    {
      label: 'common:label.source',
      name: 'source',
      type: 'select',
      tOptions: 'selections:transactionSource',
      isClearable: true,
    },
    {
      label: 'common:label.startDate',
      name: 'startDate',
      type: 'date',
      isClearable: true,
    },
    {
      label: 'common:label.endDate',
      name: 'endDate',
      type: 'date',
      isClearable: true,
    },
  ];

  btnSpan = 'col-md-12';
}

TransactionsSearchForm.propTypes = {
  onSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
};

TransactionsSearchForm.defaultProps = {
  isSubmitting: false,
};

export default withTranslation(['common', 'selections'])(TransactionsSearchForm);
